import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { LoginParams, useLogin } from 'web/services/api/queries';
import { useForm } from 'react-hook-form';
import { PrimaryButton } from 'web/components/PrimaryButton';
import { Field } from 'web/components/Field';
import { Card } from 'web/components/Card';
import GoogleLoginButton from 'web/components/GoogleLoginButton';

const LoginPage = () => {
    const { mutate: login, isLoading: isLoginLoading, error: loginError } = useLogin();
    const { register, handleSubmit, formState: { errors, isSubmitted }, clearErrors } = useForm<LoginParams>();

    const onSubmit = (data: LoginParams) => {
        login(data, {
            onSuccess: () => {
                window.location.href = '/';
            },
        });
    };

    useEffect(() => {
        if (loginError) {
            clearErrors();
        }
    }, [loginError]);

    return (
        <Card>
            <Card.Header title='Login' />
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-5">
                <Field
                    required
                    label="Email"
                    showTips={isSubmitted}
                    error={errors.email?.message}
                    tips={{
                        placeholder: "E.g.. john.doe@example.com",
                    }}
                    inputProps={{
                        ...register('email', {
                            required: true,
                            pattern: {
                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                message: "Invalid email address",
                            },
                        }),
                        autoComplete: "email",
                        type: "email",
                    }}
                />

                <Field
                    required
                    label="Password"
                    showTips={isSubmitted}
                    error={errors.password?.message}
                    tips={{
                        placeholder: "At least 8 characters with a number & symbol",
                    }}
                    inputProps={{
                        ...register('password', {
                            required: true,
                        }),
                        type: "password",
                        autoComplete: "current-password",
                    }}
                />

                {loginError && <div className="text-red-500">{loginError}</div>}
                <div className="flex flex-col md:flex-row md:gap-0 gap-2 items-center justify-between w-full">
                    <PrimaryButton type="submit" disabled={isLoginLoading}>Submit</PrimaryButton>
                    <div className='grow h-8 flex items-center justify-center'>
                        <NavLink to="/forgot-password" className="text-[#26818E] relative md:ml-[32px] font-[600]"><span className='relative z-20'>Forgot Password?</span><div className='bg-[#26818E] absolute left-[0px] bottom-[3px]  w-full h-[1px]'></div></NavLink>
                    </div>
                </div>

                <div className="relative flex items-center justify-center w-full mt-2 mb-2">
                    <div className="absolute w-full h-px bg-gray-300"></div>
                    <div className="relative px-4 bg-white text-sm text-gray-500">Or</div>
                </div>

                <GoogleLoginButton
                    onError={(error) => console.error("Google authentication error:", error)}
                />
            </form>
        </Card>
    );
};

export default LoginPage;
